import { InventoryDashboardLocationValueRow } from '@/renderer/types/inventory';
import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import {
  formatCompactCurrency,
  formatCurrencyValue,
  INVENTORY_CHART_COLORS,
} from './inventoryDashboard';

interface InventoryDashboardLocationValueCardProps {
  rows: InventoryDashboardLocationValueRow[];
}

export function InventoryDashboardLocationValueCard({
  rows,
}: InventoryDashboardLocationValueCardProps) {
  return (
    <div className="rounded-[22px] border border-gray-200 bg-white p-3.5 shadow-sm">
      <div>
        <p className="text-sm font-semibold text-slate-900">
          Stock value by location
        </p>
        <p className="mt-1 text-xs text-slate-500">
          See where inventory value is sitting right now so stores, kitchens,
          and bars stay balanced.
        </p>
      </div>

      {rows.length ? (
        <div className="mt-3 h-[220px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={rows}>
              <CartesianGrid stroke="#e5e7eb" strokeDasharray="3 3" />
              <XAxis
                dataKey="stock_location_name"
                tickLine={false}
                axisLine={false}
                tick={{ fill: '#64748b', fontSize: 12 }}
              />
              <YAxis
                tickLine={false}
                axisLine={false}
                tick={{ fill: '#64748b', fontSize: 12 }}
                tickFormatter={(value) => formatCompactCurrency(value)}
              />
              <Tooltip
                formatter={(value) => formatCurrencyValue(Number(value ?? 0))}
              />
              <Bar
                dataKey="total_stock_value"
                name="Stock value"
                radius={[10, 10, 0, 0]}
                fill={INVENTORY_CHART_COLORS.primary}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="mt-3 rounded-xl border border-dashed border-gray-200 bg-slate-50 px-4 py-6 text-sm text-slate-500">
          No stock balances have been posted to any location yet.
        </div>
      )}
    </div>
  );
}
